import React from "react";
import Footer from "../components/footer/Footer";

const termsSections = [
  {
    title: "Penggunaan Layanan",
    paragraphs: [
      "Layanan TokoMikro disediakan untuk memberikan informasi dan layanan yang berkaitan dengan produk, pembiayaan, maupun layanan digital yang kami sediakan.",
      "Pengguna wajib menggunakan layanan secara sah, bertanggung jawab, dan tidak melanggar peraturan perundang-undangan yang berlaku.",
    ],
  },
  {
    title: "Akun Pengguna",
    paragraphs: [
      "Beberapa layanan mengharuskan pengguna memiliki akun.",
      "Pengguna bertanggung jawab untuk menjaga kerahasiaan informasi akun, termasuk username dan password, serta bertanggung jawab atas seluruh aktivitas yang dilakukan melalui akun tersebut.",
    ],
  },
  {
    title: "Larangan Penggunaan",
    content: "Pengguna dilarang untuk:",
    items: [
      "Menggunakan layanan untuk tujuan yang melanggar hukum.",
      "Mengakses sistem tanpa izin.",
      "Menyebarkan virus, malware, atau kode berbahaya lainnya.",
      "Mengganggu keamanan maupun kinerja sistem.",
      "Menggunakan layanan untuk tindakan yang merugikan TokoMikro atau pihak lain.",
    ],
  },
  {
    title: "Hak Kekayaan Intelektual",
    paragraphs: [
      "Seluruh konten yang terdapat pada website dan layanan TokoMikro, termasuk namun tidak terbatas pada logo, merek dagang, desain, teks, gambar, dan perangkat lunak merupakan milik PT Toko Mikro Indonesia atau pihak yang memberikan lisensi kepada kami, serta dilindungi oleh peraturan perundang-undangan yang berlaku.",
    ],
  },
  {
    title: "Pembatasan Tanggung Jawab",
    paragraphs: [
      "Kami berupaya menyediakan layanan yang aman dan andal. Namun, kami tidak menjamin bahwa layanan akan selalu tersedia tanpa gangguan atau bebas dari kesalahan.",
      "TokoMikro tidak bertanggung jawab atas kerugian yang timbul akibat penggunaan layanan di luar kendali yang wajar, termasuk gangguan jaringan, kegagalan sistem pihak ketiga, atau keadaan kahar (force majeure).",
    ],
  },
  {
    title: "Perubahan Layanan",
    paragraphs: [
      "Kami berhak memperbarui, mengubah, atau menghentikan sebagian maupun seluruh layanan sewaktu-waktu tanpa pemberitahuan sebelumnya apabila diperlukan.",
    ],
  },
  {
    title: "Perubahan Syarat dan Ketentuan",
    paragraphs: [
      "TokoMikro dapat memperbarui Syarat dan Ketentuan ini dari waktu ke waktu. mulai berlaku sejak tanggal pembaruan.",
    ],
  },
  {
    title: "Hukum yang Berlaku",
    paragraphs: [
      "Syarat dan Ketentuan ini diatur dan ditafsirkan berdasarkan hukum Republik Indonesia.",
    ],
  },
];

const TermsOfServicePage = () => {
  return (
    <>
      <main>
        <section className="relative h-72 overflow-hidden bg-[#3f6fe5] [--hero-grid:115px] md:h-80 lg:h-96">
          <div
            className="pointer-events-none absolute inset-0 opacity-30"
            style={{
              backgroundImage:
                "linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed), linear-gradient(#aec0ed, #aec0ed)",
              backgroundRepeat: "no-repeat",
              backgroundSize:
                "var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid), var(--hero-grid) var(--hero-grid)",
              backgroundPosition:
                "calc(var(--hero-grid) * 3) 0, calc(var(--hero-grid) * 12) 0, calc(var(--hero-grid) * 13.6) var(--hero-grid), calc(var(--hero-grid) * 4) calc(var(--hero-grid) * 3), calc(var(--hero-grid) * 8) calc(var(--hero-grid) * 3)",
            }}
          ></div>
          <div
            className="absolute inset-0 opacity-70"
            style={{
              backgroundImage:
                "linear-gradient(rgba(255,255,255,0.28) 2px, transparent 2px), linear-gradient(90deg, rgba(255,255,255,0.28) 2px, transparent 2px)",
              backgroundSize: "var(--hero-grid) var(--hero-grid)",
            }}
          ></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
            <h1 className="text-3xl font-bold tracking-tight text-white drop-shadow-lg md:text-5xl lg:text-6xl">
              Terms of Service
            </h1>
            <p className="mt-4 max-w-3xl text-base leading-relaxed text-blue-100/90 drop-shadow md:text-lg">
              Selamat datang di TokoMikro. Terakhir diperbarui: 26 Juni 2026.
            </p>
          </div>
        </section>

        <section className="section-shell bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-4xl space-y-8">
              <article className="border-b border-slate-200 pb-8">
                <p className="section-copy">
                  Apabila Anda tidak menyetujui ketentuan ini, mohon untuk tidak
                  menggunakan layanan kami.
                </p>
              </article>

              {termsSections.map((section, index) => (
                <article
                  key={section.title}
                  className="border-b border-slate-200 pb-8 last:border-b-0 last:pb-0"
                >
                  <h2 className="mb-4 text-xl font-bold text-slate-900 sm:text-2xl">
                    {index + 1}. {section.title}
                  </h2>
                  {section.content && (
                    <p className="section-copy">{section.content}</p>
                  )}
                  {section.paragraphs?.map((paragraph) => (
                    <p key={paragraph} className="section-copy mb-4 last:mb-0">
                      {paragraph}
                    </p>
                  ))}
                  {section.items && (
                    <ul className="mt-4 list-disc space-y-2 pl-5 text-sm leading-7 text-slate-600 sm:text-base">
                      {section.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default TermsOfServicePage;
